﻿import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import { injectFromApp } from "../inject";

interface IFloatingContainerComponentProps {
    header?: string;
    customClass?: string;
    transparent?: boolean;
}

@injectFromApp<IFloatingContainerComponentProps>((stores) => ({}))

@observer
export class FloatingContainerComponent extends React.Component<PropsWithChildren<IFloatingContainerComponentProps>> {
    render() {
        const { props } = this;
        const { customClass, header, transparent } = props;

        return (
            <div className={"floating-container " + (customClass !== undefined ? " " + customClass : "") + (transparent !== undefined ? " transparent" : "")}>
                {header !== undefined && (
                    <div className={"header"}>
                        <h3>{header}</h3>
                    </div>
                )}
                <div className={"content"}>{this.props.children}</div>
            </div>
        );
    }
}

export type NotificationType = "" | "info" | "warning" | "error" | "success";
